import Repository from "@/repositories/Repository";

// Verb 	    URI 	                Action 	  Route Name
// GET 	      /photos 	            index 	  photos.index
// GET 	      /photos/create 	      create 	  photos.create
// POST 	    /photos 	            store 	  photos.store
// GET 	      /photos/{photo} 	    show 	    photos.show
// GET 	      /photos/{photo}/edit 	edit 	    photos.edit
// PUT/PATCH 	/photos/{photo} 	    update 	  photos.update
// DELETE 	  /photos/{photo} 	    destroy 	photos.destroy

const resource = "/communication_procedures";
export default {
  create() {
    // get the create form
    return Repository.get(`${resource}/create`);
  },
  edit(id) {
    // get the edit form
    return Repository.get(`${resource}/${id}/edit`);
  },
  validate(field, payload) {
    return Repository.post(`${resource}/validation/${field}`, payload);
  },
  index(queryString) {
    // get the list
    return queryString
      ? Repository.get(`${resource}?${queryString}`)
      : Repository.get(`${resource}`);
  },
  show(id, relationString) {
    return relationString
      ? Repository.get(`${resource}/${id}/${relationString}`)
      : Repository.get(`${resource}/${id}`);
  },
  store(payload) {
    // save the item
    return Repository.post(`${resource}`, payload);
  },
  store_from_ancillaries(payload) {
    return Repository.post(`${resource}/store-from-ancillaries`, payload);
  },
  update(id, payload) {
    // update the item
    return Repository.put(`${resource}/${id}`, payload);
  },
  destroy(id) {
    // delete the item
    return Repository.delete(`${resource}/${id}`);
  },
  aggregate(id, payload) {
    /* POST /api/communication_procedures/aggregation/:communication_procedure

    payload: {
        "unbundling": "Y|N"
    } */
    return Repository.post(`${resource}/aggregation/${id}`, payload);
  },
  schedule(id, payload) {
    /* PUT /api/communication_procedures/:id/schedule
       payload: { "status_procedure": 6|7|8, "scheduled_at": "YYYY-MM-DD HH:mm:ss" }
       Aggiorna il solo stato di invio: la update completa richiede tutto il payload. */
    return Repository.put(`${resource}/${id}/schedule`, payload);
  },
  details(id, payload) {
    /* POST /api/communication_procedures/addManualDetails/:communication_procedure

    payload: {
      custom_data: {
        date: "2022/01/01",
        description: "una descrizione"
        gross: 0
      } 
    }*/
    return Repository.post(`${resource}/addManualDetails/${id}`, payload);
  },
};
